import { useContext, useRef, useState } from 'react';
import ChevronDown from '../../../Assets/ChevronDownLargeDarkMode.svg';
import { useSelector } from 'react-redux';
import TickMark from '../../../Assets/Modals/TickMark.svg';
import { useOutsideClickForTwoRef } from '../../../Hooks/useOutsideClickForTwoRef';
import { InventoryAddProductFormContext } from '../../../Context/InventoryAddProductFormContext';
import SearchIcon from '../../../Assets/OrderManagement/SearchIcon.svg';

function SizeChart() {
    const dropdownButtonRef = useRef(null);
    const dropdownRef = useRef(null);
    const searchInputRef = useRef(null);

    const {
        selectedChart, setSelectedChart
    } = useContext(InventoryAddProductFormContext);

    useOutsideClickForTwoRef(dropdownButtonRef, dropdownRef, () => {
        setDropdownOpen(false);
        setSearchTerm(''); // clear when closing
    });

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const { sizeCharts } = useSelector((state) => state.inventoryManagement.sizeCharts);

    // Filtered list
    const filteredCharts = sizeCharts.filter(chart =>
        chart.chartName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleCategoryDropdownItemClick = (e, chart) => {
        e.stopPropagation();
        let isSelected = selectedChart.id === chart.id;

        if (isSelected) {
            setSelectedChart({});
        } else {
            setSelectedChart(chart);
        }
    };

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
        if (!dropdownOpen) {
            setTimeout(() => {
                searchInputRef.current?.focus();
            }, 100);
        }
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleSearchClick = (e) => {
        e.stopPropagation();
    };

    return (
        <div className="border border-[#EAEAEA] p-5 rounded-xl flex flex-col gap-4">
            <h1 className='font-semibold text-[18px] leading-[26px] select-none'>Size Chart</h1>

            <div className="flex flex-col gap-3">
                <div className="flex flex-col gap-2">
                    <h1 className='select-none cursor-pointer font-medium text-base text-[#121212]'>Select size chart</h1>

                    <div onClick={toggleDropdown} ref={dropdownButtonRef} className={`relative cursor-pointer px-3 py-4 border rounded-[9px] border-[#EAEAEA] bg-[#F5F5F5] flex items-center gap-[10px] ${dropdownOpen && 'border-primaryColor'}`}>
                        <div className="w-[calc(100%-24px)]">
                            <p className='font-normal select-none text-base text-[#666666] whitespace-nowrap overflow-hidden text-ellipsis'>
                                {Object.keys(selectedChart).length > 0 ? selectedChart.chartName : 'select category'}
                            </p>
                        </div>

                        <div className="w-6 h-6 flex items-center justify-center select-none">
                            <img src={ChevronDown} alt="" />
                        </div>

                        {dropdownOpen && (
                            <div ref={dropdownRef} className="absolute z-10 top-[58px] left-0 w-full border border-[#EAEAEA] rounded-xl max-h-56 overflow-y-scroll bg-[#FFFFFF] shadow-[0px_0px_12px_0px_#0000003D]">

                                {/* 🔍 Search Bar */}
                                <div className="px-3 py-4 flex items-center gap-[10px] w-full border-b border-[#EAEAEA] sticky top-0 bg-[#FFFFFF]" onClick={handleSearchClick}>
                                    <div className="w-6 h-6 flex items-center justify-center">
                                        <img src={SearchIcon} alt="" />
                                    </div>
                                    <input
                                        ref={searchInputRef}
                                        type="text"
                                        className='w-[calc(100%-24px)] outline-none'
                                        placeholder='Search size chart'
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                </div>

                                {filteredCharts.length > 0 ? (
                                    filteredCharts.map(chart => {
                                        let isSelected = selectedChart.id === chart.id;
                                        return (
                                            <div key={chart.id} onClick={(e) => handleCategoryDropdownItemClick(e, chart)} className="w-full px-3 py-4 flex gap-[10px] bg-[#FFFFFF] hover:bg-[#F5F5F5]">
                                                <div className={`w-6 h-6 rounded-md ${isSelected ? 'border-none bg-primaryAccent flex items-center justify-center' : 'border border-[#D1D5DB]'}`}>
                                                    <img className='select-none' src={isSelected ? TickMark : undefined} alt="" />
                                                </div>
                                                <p className='font-medium select-none text-base text-[#666666]'>
                                                    {chart.chartName}
                                                </p>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div className="w-full px-3 py-4 text-center">
                                        <p className='font-medium text-base text-[#999999] select-none'>No charts found</p>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SizeChart;
